import Repository from "./Repository";
import qs from "qs";
export default {
  createNewLead(payload) {
    return Repository.post(`sponsors/2311/leads`, qs.stringify(payload));
  },
};
